import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ElectionState } from '../types';
import { MinisterPhoto } from './MinisterPhoto';

interface PositionsBoardProps {
  state: ElectionState;
  large?: boolean;
  title?: string;
}

/** The positions of the election and who was elected for each ("Oficina elegida") */
export function PositionsBoard({ state, large = false, title = 'Cargos' }: PositionsBoardProps) {
  if (state.positions.length === 0) return null;
  return (
    <section className="space-y-3">
      <h2 className={cn('font-semibold opacity-80', large ? 'text-3xl' : 'text-lg')}>{title}</h2>
      <ul className={cn('grid gap-3', large ? 'grid-cols-2 xl:grid-cols-3' : 'sm:grid-cols-2')}>
        {state.positions.map((p) => {
          const winner = state.candidates.find((c) => c.id === p.winner_candidate_id);
          return (
            <li key={p.id} className={cn('flex items-center gap-4 rounded-2xl border border-current/15 bg-black/5 dark:bg-white/5', large ? 'p-4' : 'p-3')}>
              {winner ? (
                <MinisterPhoto filename={winner.photo_filename} name={winner.full_name} className={large ? 'size-20' : 'size-12'} />
              ) : (
                <div className={cn('flex shrink-0 items-center justify-center rounded-full border-2 border-dashed opacity-40', large ? 'size-20' : 'size-12')}>
                  <Crown className="size-1/2" />
                </div>
              )}
              <div className="min-w-0">
                <p className={cn('truncate opacity-70', large ? 'text-2xl' : 'text-sm')}>{p.title}</p>
                <p className={cn('truncate font-bold', large ? 'text-3xl' : 'text-base')}>
                  {winner ? winner.full_name : p.status === 'VOTING' ? 'En votación' : 'Pendiente'}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
